"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBaseAllowsDownloads = appBaseAllowsDownloads;
exports.appBaseAttachmentDisposition = appBaseAttachmentDisposition;
exports.createAppBaseAttachmentDownloadRuntime = createAppBaseAttachmentDownloadRuntime;
const app_action_validation_1 = require("./app-action-validation");
/** One sandbox decision for generated documents and original attachments. */
function appBaseAllowsDownloads(manifest) {
    return (manifest.documentExports.length > 0 ||
        manifest.attachmentDownloads.length > 0);
}
/** RFC 6266/5987: ASCII fallback plus the full, sanitized UTF-8 filename. */
function appBaseAttachmentDisposition(kind, filename) {
    const safe = (0, app_action_validation_1.sanitizeAppBaseAttachmentFilename)(filename);
    const ascii = safe.replace(/[^\x20-\x7e]/gu, '_');
    const encoded = encodeURIComponent(safe).replace(/['()*]/g, character => '%' + character.charCodeAt(0).toString(16).toUpperCase());
    return `${kind}; filename="${ascii}"; filename*=UTF-8''${encoded}`;
}
/** Self-contained browser kernel, injected unchanged in both App bridges. */
function createAppBaseAttachmentDownloadRuntime(request = fetch) {
    const messages = {
        de: {
            forbidden: 'Dieser Anhang darf nicht heruntergeladen werden.',
            missing: 'Diese Datei ist nicht mehr verfügbar.',
            failed: 'Die Datei konnte nicht heruntergeladen werden.',
        },
        en: {
            forbidden: 'This attachment cannot be downloaded.',
            missing: 'This file is no longer available.',
            failed: 'The file could not be downloaded.',
        },
    };
    return async (address) => {
        const language = (document.documentElement.getAttribute('lang') || 'en')
            .toLowerCase()
            .split('-')[0];
        const text = language === 'de' ? messages.de : messages.en;
        let response;
        try {
            response = await request(address, {
                method: 'HEAD',
                credentials: 'same-origin',
            });
        }
        catch (error) {
            throw Object.assign(new Error(text.failed), { cause: error });
        }
        if (!response.ok) {
            const message = response.status === 403
                ? text.forbidden
                : response.status === 404 || response.status === 410
                    ? text.missing
                    : text.failed;
            throw Object.assign(new Error(message), { status: response.status });
        }
        const disposition = response.headers.get('Content-Disposition') || '';
        // filename* is the last parameter; the quoted ASCII part may hold anything.
        const filenameMatch = /;\s*filename\*=UTF-8''([^;\s]+)\s*$/i.exec(disposition);
        const length = response.headers.get('Content-Length');
        if (!filenameMatch ||
            length === null ||
            !/^\d+$/.test(length) ||
            !Number.isSafeInteger(Number(length))) {
            throw new Error(text.failed);
        }
        const filename = decodeURIComponent(filenameMatch[1]);
        const anchor = document.createElement('a');
        anchor.href = address;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        return { success: true, filename, bytes: Number(length) };
    };
}
